import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Rating,
  Typography,
  Box,
} from "@mui/material";
import { axios_tenant } from "../../axios";
import { toast } from "react-toastify";
import { formatDate } from "app/utils/date";
import CircularProgress from "@mui/material/CircularProgress";

const MAX_CHAR_LIMIT = Number(process.env.REACT_APP_FEEDBACK_CHARACTER_LIMIT) || 500;

const FeedbackModal = ({ open, setOpen }) => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    const date = formatDate(Date.now());

    try {
      setLoading(true);
      await axios_tenant.post("/trexo-assistant/feedback", {
        rating,
        feedback: feedback.trim() || "NA",
        date,
      });
      toast.success("Thank you for your valuable feedback!");
    } catch (error) {
    } finally {
      setLoading(false);
      setOpen(false);
      setFeedback("");
      setRating(0);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setFeedback("");
    setRating(0);
  };

  const handleFeedbackChange = (e) => {
    const value = e.target.value;
    setFeedback(value.slice(0, MAX_CHAR_LIMIT));
  };

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>
        <Typography variant="h5" sx={{ mt: 2, mb: 2 }}>
          Feedback Form
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Rate us:
        </Typography>
        <Rating
          disabled={loading}
          value={rating}
          onChange={(e, newValue) => setRating(newValue)}
          sx={{ mb: 2 }}
        />

        <Box sx={{ position: "relative" }}>
          <TextField
            multiline
            rows={10}
            fullWidth
            variant="outlined"
            placeholder="Write your valuable feedback here..."
            value={feedback}
            onChange={handleFeedbackChange}
            disabled={loading}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mr: 1 }}>
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              color: feedback.length === MAX_CHAR_LIMIT ? "red" : "text.secondary",
            }}
          >
            {MAX_CHAR_LIMIT - feedback.length} characters left
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ m: 2 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          disabled={loading}
          sx={{
            borderColor: "#1976d2",
            color: "#1976d2",
            textTransform: "none",
            borderRadius: "8px",
            "&:hover": {
              borderColor: "#1565c0",
              backgroundColor: "#e3f2fd",
            },
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !rating}
          sx={{
            backgroundColor: "#1976d2",
            borderColor: "#1976d2",
            color: "#fff",
            textTransform: "none",
            borderRadius: "8px",
            "&:hover": {
              borderColor: "#1976d2",
              backgroundColor: "#1976d2",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ color: "blue" }} />
          ) : (
            <span>Submit Feedback</span>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackModal;
